export default __webpack_public_path__ + "static/herobanner-monthly-card-fees-8784772bb1025b4ebb69c0613e450a8e.webp";